import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MessageService from '../../../services/MessageService';
import { useParams, Redirect } from 'react-router-dom';
import { getPathApp } from '../../../utils/util';

const pathurl = getPathApp(window);

const Notification = (props) => {
    const { id } = useParams();
    const [url, setUrl] = useState();

    useEffect(() => {
        props.getNotification(id, (response) => {
            if (response && response.url) {
                setUrl(response.url);
                props.notificationUpdate(response);
            }
        });
        // eslint-disable-next-line
    }, []);

    return (
        <div>
            {url && (
                <Redirect
                    to={{
                        pathname: `${pathurl}/${url}`
                    }}
                />
            )}
        </div>
    );
};

const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getNotification: (id, callback) => {
            dispatch(MessageService.GetNotificationById(id, callback));
        },
        notificationUpdate: (notification) => {
            dispatch(MessageService.PutNotification(notification));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Notification));
